module.exports = __webpack_public_path__ + "img/2303.91c95ee3.gif";